module.exports = __webpack_public_path__ + "img/canterAD.b3fda369.png";